export default __webpack_public_path__ + "static/media/IResponsiveLogoFullSize.4be24067.png";